import React from "react";
import { Box } from "@chakra-ui/react";

export const CopyIcon = (props) => {
  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
      >
        <path
          fill="#424770"
          fillRule="nonzero"
          d="M 4 2 C 2.894531 2 2 2.894531 2 4 L 2 18 L 4 18 L 4 4 L 18 4 L 18 2 Z M 8 6 C 6.894531 6 6 6.894531 6 8 L 6 20 C 6 21.105469 6.894531 22 8 22 L 20 22 C 21.105469 22 22 21.105469 22 20 L 22 8 C 22 6.894531 21.105469 6 20 6 Z M 8 8 L 20 8 L 20 20 L 8 20 Z M 8 8 "
        />
      </svg>
    </Box>
  );
};
